// en/views/channelOta.js
export const channelOta = {
  common: {
    listing: "Annuncio",
    back: "Indietro",
    close: "Chiudi",
    cancel: "Annulla",
    flexible: "Flessibile",
    noResults: "Nessuna corrispondenza",
    deleteConn: "Elimina connessione",
  },
  head: {
    manage: "Gestisci {channel}",
    airbnbConfig: "Impostazioni Airbnb",
    channelOptions: "Opzioni del canale",
  },
  picker: {
    placeholder: "Cerca o scegli un annuncio…",
  },
  loading: {
    status: "Caricamento dello stato del canale…",
    listings: "Caricamento dei tuoi annunci Airbnb…",
    settings: "Caricamento delle impostazioni dell'annuncio…",
  },
  accounts: {
    title: "Su quale dei tuoi account {channel}?",
    lead: "Hai già un account {channel} collegato. Puoi aggiungere questo annuncio oppure collegare un altro account. | Hai già {n} account {channel} collegati. Scegli a quale appartiene questo annuncio, o collegane un altro.",
    account: "Account {n}",
    empty: "Ancora nessun annuncio",
    andMore: "{list} e altri {rest}",
    newTitle: "Collega un altro account {channel}",
    newDesc: "Per annunci che stanno su un account diverso",
  },
  confirm: {
    title: "Elimina la connessione {channel}",
    desc: "Il canale verrà rimosso dal channel manager e dalle tue connessioni attive.",
    coversPre: "Questa connessione copre ",
    coversCount: "{count} annuncio | {count} annunci",
    coversPost: " e verrà disconnessa da tutti: {list}",
    purgePre: "Eliminare anche le prenotazioni importate? Scegli quali camere ",
    purgeNote: "(possono essere recuperate)",
    selectAll: "Tutte",
    unselectAll: "Deseleziona tutte",
    delete: "Elimina",
    detachOnly: "Scollega solo questo annuncio",
    deleteAll: "Elimina e scollega {count} annuncio | Elimina e scollega tutti i {count} annunci",
    deleteWithResv: "Elimina (+{count} prenotazione) | Elimina (+{count} prenotazioni)",
  },
  gone: {
    title: "Questa connessione non esiste più sul canale",
    desc: "Il canale è stato eliminato nel channel manager. Elimina questa connessione per ricollegarla da “Connetti ora”.",
  },
  menu: {
    channelOptDesc: "Attiva o metti in pausa, modifica la mappatura, sincronizza, importa le prenotazioni o elimina la connessione.",
    airbnbCfgDesc: "Orari di check-in/out, preavviso, prezzi e pulizia per ogni annuncio.",
  },
  channel: {
    statusLabel: "Stato del canale",
    active: "Attivo",
    inactive: "Inattivo",
    deactivate: "Disattiva canale",
    activate: "Attiva canale",
    pending: "In revisione",
    hintPending: "Il canale è collegato e ha già i tuoi dati. Manca che il canale esamini e accetti la tua struttura; quando lo farà si attiva da solo. Di solito ci vuole qualche giorno. Se passa di più, scrivici e lo controlliamo.",
    hintActive: "Il canale è attivo: inviamo prezzi e disponibilità. Disattivalo per mettere in pausa l'invio senza perdere la mappatura.",
    blockersTitle: "Manca qualcosa perché il canale si attivi",
    blockersHint: "Premi di nuovo “Connetti” nella procedura guidata: lo sistemiamo e lo rinviamo.",
    hintInactive: "Il canale è connesso ma in pausa. Attivalo per iniziare a inviare prezzi e disponibilità.",
    editTitle: "Modifica canale",
    editDesc: "Modifica o aggiungi camere e piani tariffari mappati su questo canale.",
    editBtn: "Modifica mappatura",
    fullSyncTitle: "Sincronizzazione completa",
    fullSyncDesc: "Reinvia tutti i prezzi, la disponibilità e le restrizioni al canale.",
    synced: "Sincronizzato",
    sync: "Sincronizza",
    extractTitle: "Importa prenotazioni future",
    extractDesc: "Importa in WACheckin le prenotazioni che hai già sul canale.",
    imported: "Importate",
    extract: "Importa",
    resyncTitle: "Reimporta prenotazioni",
    resyncDesc: "Recupera di nuovo tutte le prenotazioni del canale e riassegnale con la mappatura attuale. Usalo se hai scelto l'annuncio sbagliato o se mancano delle prenotazioni.",
    resync: "Reimporta",
  },
  cfg: {
    emptyNoListings: "Non hai ancora abbinato alcun annuncio. Vai su <b>Opzioni del canale → Modifica mappatura</b> per collegare i tuoi annunci Airbnb con le tue unità.",
    emptyNoMapping: "Questa struttura non ha ancora alcun annuncio Airbnb abbinato. Vai su <b>Opzioni del canale → Modifica mappatura</b> e abbina il suo annuncio per impostare qui orari e prezzi.",
  },
  arrival: {
    section: "Arrivo e partenza",
    lead: "A che orari e in quali giorni i tuoi ospiti possono effettuare il check-in e il check-out.",
    checkInFrom: "Check-in da",
    checkInFromTip: "Orario più anticipato in cui un ospite può effettuare il check-in.",
    checkInTo: "Check-in fino a",
    checkInToTip: "Orario più tardo in cui un ospite può arrivare.",
    checkOut: "Check-out",
    checkOutTip: "Orario massimo entro cui l'ospite deve lasciare la struttura.",
    unset: "Non impostato",
    daysIn: "Giorni in cui è consentito il check-in",
    daysInTip: "Giorni della settimana in cui un ospite può effettuare il check-in.",
    daysOut: "Giorni in cui è consentito il check-out",
    daysOutTip: "Giorni della settimana in cui un ospite può effettuare il check-out.",
  },
  booking: {
    section: "Prenotazioni",
    window: "Finestra di disponibilità",
    windowTip: "Con quanto anticipo il tuo calendario si apre alla vendita. È ciò che Airbnb chiama 'finestra di disponibilità' (12 mesi = 365 giorni). NON è il numero massimo di notti per soggiorno.",
    minLead: "Preavviso minimo",
    minLeadTip: "Con quanto anticipo rispetto all'arrivo è possibile prenotare. Impedisce le prenotazioni dell'ultimo minuto.",
    maxStay: "Soggiorno massimo",
    maxStayTip: "Numero massimo di notti per prenotazione. È il 'massimo di notti' di Airbnb, diverso dalla finestra di disponibilità.",
    turnover: "Giorni tra le prenotazioni",
    turnoverTip: "Giorni bloccati tra un check-out e il check-in successivo, per pulire e preparare.",
  },
  rules: {
    section: "Regole di prenotazione",
    cancelPolicy: "Politica di cancellazione",
    cancelPolicyTip: "Quanto l'ospite può recuperare in caso di cancellazione. Flessibile = più indulgente; Rigida = rimborso minore.",
    whoCanBook: "Chi può prenotare",
    whoCanBookTip: "Chi può prenotare immediatamente senza la tua approvazione preventiva.",
  },
  prices: {
    section: "Prezzi",
    perNight: "Prezzo a notte",
    weekend: "Prezzo del weekend",
    weekendTip: "Prezzo per venerdì e sabato. Lascialo uguale al prezzo a notte se non vuoi differenze.",
    guestsIncluded: "Ospiti inclusi",
    guestsIncludedTip: "Numero di ospiti senza costi aggiuntivi.",
    extraGuest: "Prezzo per ospite aggiuntivo",
    extraGuestTip: "Costo per ogni ospite aggiuntivo, a notte, oltre a quelli inclusi.",
  },
  cleaning: {
    section: "Pulizia",
    notePre: "Compila entrambi affinché ogni prenotazione paghi la pulizia. La tariffa per i soggiorni lunghi deve essere ",
    noteStrong: "uguale o superiore",
    notePost: " rispetto a quella per i soggiorni brevi. Se ne lasci una a 0, quel tipo di soggiorno non pagherà la pulizia.",
    long: "Pulizia · soggiorno lungo",
    longTip: "Addebitata sui soggiorni lunghi. Deve essere uguale o superiore alla tariffa per i soggiorni brevi.",
    short: "Pulizia · soggiorno breve",
    shortTip: "Addebitata sui soggiorni brevi (poche notti).",
    error: "La tariffa di pulizia per i soggiorni lunghi ({sym}{long}) deve essere uguale o superiore a quella per i soggiorni brevi ({sym}{short}).",
  },
  tax: {
    section: "Tassa di soggiorno",
    lead: "Imposta locale che addebiti all'ospite e dichiari tu stesso (non Airbnb). Lasciala a 0 se non è applicabile.",
    amount: "Importo",
    amountTip: "Importo dell'imposta. Imposta 0 per non applicarla.",
    charged: "Addebito",
    chargedTip: "Come viene calcolata l'imposta: per ospite a notte, per notte o per ospite.",
    perGuestNight: "Per ospite a notte",
    perNight: "Per notte",
    perGuest: "Per ospite",
    attestation: "Confermo che queste informazioni sono corrette e di assumermi la responsabilità dell'addebito e della dichiarazione di questa imposta.",
  },
  footer: {
    save: "Salva impostazioni",
    saving: "Salvataggio…",
  },
  opts: {
    noticeNoLimit: "Nessun limite (tutte le date)",
    months: "{count} mese | {count} mesi",
    maxNoLimit: "Nessun limite",
    nights: "{count} notte | {count} notti",
    maxNights: "Massimo ({count})",
    cancelModerate: "Moderata",
    cancelFirm: "Rigorosa",
    cancelStrict: "Rigida",
    instantEveryone: "Qualsiasi ospite",
    instantWellReviewed: "Ospiti con buone recensioni",
    instantVerified: "Identità verificata",
    instantReviewedVerified: "Recensioni + identità",
    leadNone: "Nessun preavviso",
    hours: "{count} ora | {count} ore",
    days: "{count} giorno | {count} giorni",
  },
  msg: {
    loadSettingsError: "Impossibile caricare le impostazioni dell'annuncio.",
    taxAttestationWarn: "Spunta la casella di conferma per applicare la tassa di soggiorno.",
    saveOk: "Impostazioni Airbnb salvate e inviate al canale.",
    saveError: "Impossibile salvare le impostazioni.",
    statusError: "Impossibile caricare lo stato del canale.",
    activated: "Canale attivato.",
    deactivated: "Canale disattivato.",
    toggleError: "Impossibile modificare lo stato del canale.",
    resyncOk: "Prenotazioni reimportate: {imported}.",
    resyncOkWarn: "Prenotazioni reimportate: {imported} ({errors} con un avviso).",
    resyncError: "Impossibile reimportare le prenotazioni.",
    disconnectError: "Impossibile eliminare la connessione.",
    fullSyncOk: "Sincronizzazione completa inviata.",
    extractOk: "Prenotazioni future importate.",
    actionError: "Impossibile eseguire l'azione.",
  },
  rate: {
    apply: "Applica",
    or: "oppure",
    usePlan: "usa una delle tue tariffe…",
  },
};
